import { cleanQueryParams } from '../utils/queryParams';
import { handleApiCalls } from './axiosInstance';
import BaseAPI from './baseAPI';

class MetabaseAPI extends BaseAPI {
  constructor() {
    super({ suffix: 'metabase' });
  }

  /**
   * Fetch Metabase report URL for iframe
   * @param {string} reportId
   * @param {object} params
   * @param {string?} params.companyId
   * @param {string?} params.userId
   */
  async fetchMetabaseReportURL(reportId, params = {}) {
    const cleanParams = cleanQueryParams({ ...params });
    const result = await handleApiCalls('get', `${this.baseUrl}/${reportId}/url?${cleanParams}`);
    return result.data;
  }
}

export default MetabaseAPI;
